import Content from '@webclient/components/pages/home/sections/bots/content';

export default function Bots() {
  return <Content />;
}
